<template>
  <div v-loading="loading">
    <ExamStudentForm
        :unlocked-tabs="unlockedTabs"
        :readonly="false"
        :type-exam="typeExam"
        :data-exam="dataExam"
        :question-index="questionIndex"
        :active-name="activeName"
        :isTestOnline="isTestOnline"
        @cheatingNext="handleCheatingNext"
        @go-next="handleNext"
        @go-back="handleBack"
        @handleClick="handleClick"
        @update:active-name="(newActiveName) => activeName = newActiveName"
        @backCheatTab="backCheatTab"
        :templateMark="templateMark"
        @next-step-mark-zero="handleNextStepMarkZero"
        :disabled="disabledSubmit"
    />
  </div>
</template>

<script>
import ExamStudentForm from '../../pages/marking-exam/components/ExamStudentForm.vue'

import {SPEAKING, WRITING} from '@/common/courseTemplate.js'
import {getEvaluationTemplate, isV3Rubric } from '@/common/markingTemplate'
import {GET_EXAM_WITH_ANSWER, GET_SPEAKING_AI_RESULT, MARK_CHEATING, MARK_EXAM_SUBMISSIONS} from "@/core/services/store/marking/marking.module";
import {GET_WRITING_AI_RESULT} from "@/core/services/store/course/classes.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  name: 'MarkExamStudent',
  components: {ExamStudentForm},
  data() {
    return {
      loading: false,
      tabKeys: [],
      dataExam: [],
      unlockedTabs: ['checkCheating'],
      questionIndex: 0,
      questionSpeakingIndex: 0,
      templateMark: {},
      activeName: 'checkCheating',
      SPEAKING,
      WRITING,
      isCheatingMarked: false,
      typeExamWriting: null,
      isTestOnline: false,
      disabledSubmit: false,
      isLowBand: false,
      markingVersion: 2,
    }
  },
  computed: {
    isWritingExam() {
      return +this.$route.query.type === 1 || this.$route.query.type == 8
    },
    typeExam() {
      return this.isWritingExam ? WRITING : SPEAKING
    },
    questionExam() {
      return this.isWritingExam ? this.dataExam[this.questionIndex] : this.dataExam[0]
    }
  },
  watch: {
    questionIndex(newIndex, oldIndex) {
      if (newIndex === 1) {
        this.resetTabs()
        this.scrollToTop()
      }
    }
  },
  methods: {
    checkWritingItemsData(items = []) {
      const errors = [];

      items.forEach((group) => {
        const groupKey = group.key;
        const groupLabel = group.label;

        // 1️⃣ Check comment_detail của group
        if (!group.comment_detail || group.comment_detail.trim() === "") {
          errors.push({
            type: "GROUP_COMMENT_EMPTY",
            groupKey,
            groupLabel,
            message: `Thiếu comment_detail ở nhóm "${groupLabel}"`
          });
        }

        (group.items || []).forEach((criterion) => {
          const {key, label, criterion_score} = criterion;

          if (
              criterion_score === "" ||
              criterion_score === null ||
              criterion_score === undefined
          ) {
            errors.push({
              type: "CRITERION_SCORE_EMPTY",
              groupKey,
              groupLabel,
              criterionKey: key,
              criterionLabel: label,
              message: `Chưa chấm điểm tiêu chí "${label}" (${groupLabel})`
            });
          }
        });
      });

      return {
        isValid: errors.length === 0,
        errors
      };
    },
    showIncompleteNotification() {
      const examType = this.typeExam === this.SPEAKING ? 'speaking' : 'writing'
      this.$message.warning(`Bạn chưa hoàn thành chấm điểm bài ${examType}`)
    },
    unlockTab(key) {
      if (!this.unlockedTabs.includes(key)) this.unlockedTabs.push(key)
    },
    goToNextTab(nextKey) {
      this.unlockTab(nextKey)
      this.activeName = nextKey
      this.scrollToTop()
    },
    resetTabs() {
      const firstKey = this.templateMark.items?.[0]?.key || ''
      this.unlockedTabs = ['checkCheating']
      if (firstKey) this.unlockedTabs.push(firstKey)
      this.activeName = 'checkCheating'
      this.isCheatingMarked = false
    },
    scrollToTop() {
      this.$nextTick(() => {
        const container = document.querySelector('.el-tabs__content')
        if (container) {
          container.scrollTo({top: 0, behavior: 'smooth'})
        } else {
          window.scrollTo({top: 0, behavior: 'smooth'})
        }
      })
    },
    handleClick(currentKey) {
      const currentIndex =  this.templateMark.items.findIndex(item => item.key === currentKey)
      const nextGroup = this.templateMark.items[currentIndex + 1]
      this.unlockedTabs = ['checkCheating', ...this.dataExam[this.questionIndex].items.map(g => g.key)]
      this.activeName = this.dataExam[this.questionIndex].items[0].key
      this.scrollToTop()
    },
    transformData(dataRaw) {
      return dataRaw.map(task => ({
        cheating: task.cheating,
        teacher_marks: task.items.flatMap(group =>
            group.items.map(item => ({
              key: item.key,
              label: item.label,
              label_parent: group.label,
              key_parent: group.key,
              comment_auto: item.comment_auto || '',
              comment_detail: group.comment_detail || '',
              score: item.criterion_score >= 0 ? item.criterion_score : null,
              e_comment_auto: item.e_comment_auto || '',
            }))
        ),
        has_submitted: task.didStudentDo?.value?? true
      }))
    },
    isGroupCompleted(group) {
      const allScored = group && group.items && group.items.every(item => item.criterion_score !== undefined && item.criterion_score !== null)
      const hasComment = group && group.comment_detail && group.comment_detail.trim().length > 0
      return allScored && hasComment
    },
    async handleCheatingNext(cheatingData) {
      if (cheatingData && cheatingData.type === 1) {
        try {
          this.isCheatingMarked = true;
          const payload = {
            marking_retake_id: this.$route.query.marking_retake_id,
            description: cheatingData.description,
            has_submitted: cheatingData.has_submitted ?? true
          };
          await this.$store.dispatch(MARK_CHEATING, payload);

          if (this.typeExam === SPEAKING) {
            await this.submitFinalMark();
          } else {
            if (this.dataExam && this.questionIndex === 0 && this.dataExam.length > 1) {
              this.questionIndex += 1;
              this.$nextTick(() => {
                this.resetTabs();
                this.scrollToTop();
                this.$message.warning('Đã bỏ qua chấm điểm do đạo văn >= 50%. Chuyển sang bài viết tiếp theo.');
              });
            } else {
              await this.submitFinalMark();
            }
          }
        } catch (error) {
          this.$message.error(error?.data?.message || 'Không thể xử lý đạo văn. Vui lòng thử lại.');
        }
      }
    },
    async handleNext(currentKey) {
      
      const currentIndex = this.templateMark?.items.findIndex(item => item.key === currentKey)
      const group = this.questionExam?.items?.[currentIndex]
      const nextGroup = this.templateMark?.items?.[currentIndex + 1]
      // if (!this.isCheatingMarked && !this.isGroupCompleted(group)) {
      //   this.showIncompleteNotification()
      //   return
      // }

      // if (nextGroup) {
      //   this.goToNextTab(nextGroup.key)
      //   return
      // }
      if (!this.checkWritingItemsData(this.dataExam[this.questionIndex].items).isValid) {
        this.$message.warning('Vui lòng chấm điểm và nhận xét cho tất cả tiêu chí trước khi tiếp tục.')
        return
      }

      if (this.typeExam === WRITING && this.dataExam && this.dataExam.length > 1 && this.questionIndex === 0) {
        this.questionIndex += 1
        this.$nextTick(() => {
          this.resetTabs()
          this.scrollToTop()
          this.$notify({
            title: 'Chuyển bài viết',
            message: 'Bạn đã chấm xong. Chuyển sang bài viết tiếp theo.',
            type: 'success'
          })
        })
      } else {
        await this.submitFinalMark()
      }
    },


    async submitFinalMark() {
        const loading = this.$loading({
        lock: true,
        text: 'Đang lưu kết quả chấm điểm',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        this.disabledSubmit = true
        const writingData = this.dataExam.map(q => ({
          cheating: q.cheating,
          question_id: q.question_id,
          items: q.items
        }))
        const payload = {
          marking_exam_retake_id: +this.$route.query.marking_retake_id,
          academic_task_id: +this.$route.query.academic_task_id,
          version: this.markingVersion,
        }

        if (this.typeExam === SPEAKING) {
          payload.speakings = this.transformData(this.dataExam)[0]
        } else {
          payload.writings = this.transformData(writingData)
        }

        const res = await this.$store.dispatch(MARK_EXAM_SUBMISSIONS, payload)
        if (res.error) {
          this.$message.error('Không thể lưu kết quả chấm điểm')
          return
        }
        this.$message.success('Bạn đã chấm xong toàn bộ bài thi. Dữ liệu đã được lưu')
        await this.$router.push({
          name: 'PersonalTaskList'
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.disabledSubmit = false
         loading.close();
      }
    },
    handleBack(currentKey) {
      const currentIndex = this.templateMark.items.findIndex(item => item.key === currentKey)
      if (currentIndex === 0) {
        this.activeName = 'checkCheating'
        return
      }
      const prevGroup = this.templateMark.items[currentIndex - 1]
      if (prevGroup && this.unlockedTabs.includes(prevGroup.key)) {
        this.activeName = prevGroup.key
      }
    },
    getTemplate(rubricKey, index = 0) {
      this.isLowBand = ['marking.basic', 'marking.pre', 'marking.basic.v3', 'marking.pre.v3'].includes(rubricKey)
      this.markingVersion = isV3Rubric(rubricKey) ? 3 : 2
      this.templateMark = getEvaluationTemplate(rubricKey, this.typeExam, index)
      return this.templateMark
    },
    applyAIResult(DataAI) {
      if (!DataAI || !DataAI.length) return
      this.dataExam.forEach((exam, index) => {
        if (DataAI.length > 1) {
          DataAI.sort((a, b) => {
            if (a.course_type === 'HighTask1') return -1;
            if (b.course_type === 'HighTask1') return 1;
            return 0;
          });
        }
        let aiEntry = DataAI[index]
        
        if (!aiEntry) return
        const AIResult = aiEntry.score_breakdown ?? null
        const ConfidenceAI = aiEntry.confidence
        const overallScoreAI = aiEntry.final_score
        const isAIMarkFull =
          (this.isLowBand && ConfidenceAI?.confidence_raw >= 9 && overallScoreAI >= 6 && overallScoreAI <= 8) ||
          (!this.isLowBand && ConfidenceAI?.raw_score >= 9 && overallScoreAI > 4)
        exam.isAI = isAIMarkFull
        if (!AIResult) return
        exam.items?.forEach(item => {
          const parentAI = AIResult.find(ai => ai?.key === item?.key)
          if (!parentAI) return
          item.comment_detail = parentAI.comment
          item.disable = isAIMarkFull
          item.items?.forEach(itemChild => {
          const ParentKeyChildAI = parentAI?.sub_criteria?.find(itemChildAI => itemChildAI?.key === itemChild?.key)
            const childAI = parentAI.sub_criteria?.find(ai => ai?.key === itemChild?.key)
            if (childAI && isAIMarkFull) {
              itemChild.criterion_score = childAI.point ?? ''
              itemChild.comment_auto = itemChild?.items?.find(child=>child?.score === ParentKeyChildAI?.point)?.comment??'' 
              itemChild.disable = true
            }
          })
        })
      })
    },
    applySpeakingAiPrefill(aiResult) {
      if (aiResult?.status !== 'ready' || !this.dataExam[0]) return

      const speakingExam = this.dataExam[0]

      if (aiResult.cheating) {
        speakingExam.cheating = aiResult.cheating
      }

      const feedbackCriteria = Array.isArray(aiResult.evidence?.feedback?.criteria)
        ? aiResult.evidence.feedback.criteria
        : []
      const feedbackByGroup = feedbackCriteria.reduce((feedback, criterion) => {
        if (!criterion?.key) return feedback
        feedback[criterion.key] = criterion.comment
        return feedback
      }, {})

      const teacherMarks = Array.isArray(aiResult.teacher_marks) ? aiResult.teacher_marks : []
      const marksByGroup = teacherMarks.reduce((groups, mark) => {
        if (!groups[mark.key_parent]) groups[mark.key_parent] = {}
        groups[mark.key_parent][mark.key] = mark
        return groups
      }, {})

      speakingExam.items = speakingExam.items.map(group => {
        const groupMarks = marksByGroup[group.key] || {}
        const firstMark = Object.values(groupMarks)[0]

        return {
          ...group,
          comment_detail: firstMark?.comment_detail ?? feedbackByGroup[group.key] ?? group.comment_detail,
          items: !aiResult.is_gate_passed ? group.items : group.items.map(item => {
            const mark = groupMarks[item.key]
            if (!mark) return item

            return {
              ...item,
              criterion_score: mark.score,
              comment_auto: mark.comment_auto || ''
            }
          })
        }
      })
    },
    async getSpeakingAiResult() {
      try {
        const response = await this.$store.dispatch(GET_SPEAKING_AI_RESULT, this.$route.query.academic_task_id)
        if (!response?.error) {
          this.applySpeakingAiPrefill(response?.data)
          console.log('AI prefill applied successfully:', response?.data)
        }
      } catch (error) {
        // AI prefill is optional; retain the manual grading flow on any API error.
      }
    },
    // same cloneDeep lodash
    cloneDeep(value, seen = new WeakMap()) {
      if (value === null || typeof value !== 'object') {
        return value;
      }
      if (seen.has(value)) {
        return seen.get(value);
      }
      let clone;
      switch (true) {
        case value instanceof Date:
          clone = new Date(value);
          break
        case Array.isArray(value):
          clone = [];
          seen.set(value, clone);
          for (let i = 0; i < value.length; i++) {
            clone[i] = this.cloneDeep(value[i], seen);
          }
          break;
        case value instanceof Map:
          clone = new Map();
          seen.set(value, clone);
          value.forEach((v, k) => {
            clone.set(k, this.cloneDeep(v, seen));
          });
          break;
        case value instanceof Set:
          clone = new Set();
          seen.set(value, clone);
          value.forEach(v => {
            clone.add(this.cloneDeep(v, seen));
          });
          break;
        default:
          clone = Object.create(Object.getPrototypeOf(value));
          seen.set(value, clone);
          for (const key of Object.keys(value)) {
            clone[key] = this.cloneDeep(value[key], seen);
          }
      }
      return clone;
    },

    async getExamWithAnswer() {
      this.loading = true
      try {
        const markingRetakeId = this.$route.query.marking_retake_id
        if (!markingRetakeId) {
          this.$message.error('Thiếu thông tin bài thi')
          return
        }

        const payload = {
          marking_retake_id: markingRetakeId,
          academic_task_id: this.$route.query.academic_task_id
        }

        const res = await this.$store.dispatch(GET_EXAM_WITH_ANSWER, payload)
        if (res.error) {
          this.$message.error('Không thể lấy dữ liệu bài thi')
          return
        }
        this.typeExamWriting = res.data.exam_form
        const examData = res.data.data
        if (!examData) {
          this.$message.error('Không có dữ liệu bài thi')
          return
        }
        const rubricKey = res.data?.rubric?.key

        this.getTemplate(rubricKey)
        const templateItems = this.templateMark?.items
        if (!Array.isArray(templateItems)) {
          this.$message.error('Không thể tải template chấm điểm')
          return
        }

        const cloneItems = () => this.cloneDeep(templateItems)
        if (examData && Array.isArray(examData)) {
          switch (this.typeExam) {
            case WRITING:
              this.dataExam = examData.map((writing,index) => {
                return {
                  cheating: {type: null, description: ''},
                  questions: {...writing},
                  items: this.cloneDeep(getEvaluationTemplate(rubricKey, this.typeExam, index).items),
                  didStudentDo: {value: true},
                  isAI: false,
                }
              })
              try {
                const aiResponse = await this.$store.dispatch(GET_WRITING_AI_RESULT, this.$route.query.marking_retake_id)
                this.applyAIResult(aiResponse?.data ?? [])
              } catch (e) {
                console.log('Error fetching AI result:', e)
              }
              return
            case SPEAKING:
              this.dataExam = [
                {
                  cheating: {type: null, description: ''},
                  questions: examData,
                  items: cloneItems(),
                  didStudentDo: {value: true},
                }
              ]
              await this.getSpeakingAiResult()
              return
            default:
              return []
          }
        }
        this.tabKeys = this.cloneDeep(templateItems.map(item => item.key))
        this.resetTabs()
      } catch (error) {
        switch (error.response?.status) {
          case 404:
            this.$message.error('Không tìm thấy bài thi')
            break
          case 401:
            this.$message.error('Phiên đăng nhập đã hết hạn')
            break
          case 403:
            this.$message.error('Bạn không có quyền truy cập bài thi này')
            break
          default:
            this.$message.error('Lỗi khi tải dữ liệu bài thi: ' + (error.message || 'Lỗi không xác định'))
        }
      } finally {
        this.loading = false
      }
    },
    backCheatTab() {
      this.unlockedTabs = ['checkCheating']
      this.activeName = 'checkCheating'
    },
    handleNextStepMarkZero() {
      if(this.dataExam.length === (this.questionIndex + 1)) {
        this.submitFinalMark()
        return
      }
      this.questionIndex += 1
      this.$nextTick(() => {
        this.resetTabs()
        this.scrollToTop()
        this.$notify({
          title: 'Chuyển bài viết',
          message: 'Bạn đã chấm xong. Chuyển sang bài viết tiếp theo.',
          type: 'success'
        })
      })
    }
  },
  mounted() {
    this.getExamWithAnswer()
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Chấm thi", name: 'MarkExamStudent'},
      {title: "Quản lý tác vụ"}
    ]);
  }
}
</script>
